import React from 'react'

class _Module extends React.Component {
  render() {
    return <div></div>
  }
}

export default _Module